import { RECEIVE_BUSINESS_VERIFICATION_DATA } from '../constants/actionTypes';
import { GET_PROPERTY_DETAILS, GET_USER } from '../constants/requests';
import { getIsCurrentUserAnAdmin, getNeedsApplicationManager } from '../utils/businessVerification';

const initState = {
  propertyId: '',
  restrictions: {},
  city: '',
  state: '',
  isMultifamily: false,
  listingTitle: '',
  street: '',
  unit: '',
  zip: '',
  productType: '',
  propertyPhotos: [],
  active: false,
  geo: {
    lat: 47.6072514,
    lon: -122.3387425,
  },
  isConnectedExperience: true,
  listingAlias: '',
  listingType: {},
  rentGuarantee: {},
  floorPlans: [],
  laundry: '',
  petsAllowed: {},
  propertyType: '',
  buildingAttributes: {},
  garageParking: false,
  offStreetParking: false,
};

export default function listingReducer(state = initState, action) {
  switch (action.type) {
    case GET_USER.RECEIVE: {
      const { applicationsEnabled } = action.response.data.response;
      return {
        ...state,
        enrollmentOn: applicationsEnabled,
      };
    }
    case RECEIVE_BUSINESS_VERIFICATION_DATA: {
      if (!getNeedsApplicationManager(action.data)) {
        return state;
      }
      const isCurrentUserAnAdmin = getIsCurrentUserAnAdmin(action.data, action.userIdIrene);
      return {
        ...state,
        restrictions: {
          ...state.restrictions,
          isBvlRestricted: !isCurrentUserAnAdmin,
        },
      };
    }
    case GET_PROPERTY_DETAILS.RECEIVE: {
      const {
        restrictions,
        city,
        state: postalState,
        isMultifamily,
        listingTitle,
        street,
        unit,
        zip,
        active,
        productType,
        propertyPhotos,
        propertyId,
        isConnectedExperience,
        listingAlias,
        listingType,
        rentGuarantee,
        floorPlans,
        laundry,
        petsAllowed,
        propertyType,
        buildingAttributes,
        garageParking,
        offStreetParking,
      } = action.propertyDetails ?? {};
      const { eventProductType, hasNeverBeenActivated, isApplicationsAccepted } = action.propertyAnalytics ?? {};
      return {
        ...state,
        state: postalState,
        restrictions,
        city,
        isMultifamily,
        listingTitle,
        street,
        unit,
        zip,
        productType,
        propertyPhotos,
        active,
        propertyId,
        isConnectedExperience,
        listingAlias,
        listingType,
        rentGuarantee,
        floorPlans,
        laundry,
        petsAllowed,
        propertyType,
        buildingAttributes,
        eventProductType,
        hasNeverBeenActivated,
        isApplicationsAccepted,
        garageParking,
        offStreetParking,
      };
    }
    default:
      return state;
  }
}
